export default {
  "content": "<g clip-path=\"url(#clip0_853_11145)\"><path d=\"M9 4.912h2a1 1 0 001 1h3a1 1 0 001-1v-3a1 1 0 00-1-1h-3a1 1 0 00-1 1v1H8a1 1 0 00-1 1v4.5H5v-.5a1 1 0 00-1-1H1a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1v-.5h2v4.5a1 1 0 001 1h3a1 1 0 001 1h3a1 1 0 001-1v-3a1 1 0 00-1-1h-3a1 1 0 00-1 1v1H9v-9z\" fill=\"#5C6270\"/></g><defs><clipPath id=\"clip0_853_11145\"><path fill=\"#fff\" transform=\"translate(0 .912)\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "16",
    "height": "17",
    "viewBox": "0 0 16 17",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};